import React from "react";
import { Stack, Button } from "@mui/material";
import CoordinatesInput from "../CoordinatesInput/CoordinatesInput";

import "./RookieCoordinateInput.scss";

const RookieCoordinateInput = ({
  latitude,
  addMarker,
  longitude,
  handleLngChange,
  handleLatChange,
}) => {
  return (
    <Stack direction="row" spacing={2}>
      <CoordinatesInput
        maxAbs={90}
        label="Latitude"
        value={latitude}
        autoDecimalAt={2}
        placeholder="00.0000"
        handleValueChange={handleLatChange}
      />
      <CoordinatesInput
        maxAbs={180}
        maxLength={7}
        label="Longitude"
        value={longitude}
        autoDecimalAt={1}
        placeholder="00.0000"
        handleValueChange={handleLngChange}
      />

      <Stack className="input-wrapper">
        <Button
          variant="contained"
          onClick={addMarker}
          className="btn button"
          size="small"
          //   disabled={latitude && longitude}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
export default RookieCoordinateInput;
